import { createContext, useContext } from 'react';
export const PageScrollContext = createContext({
    scrollableContentRef: { current: null },
});
export const usePageScrollContext = () => useContext(PageScrollContext);
//# sourceMappingURL=PageScrollContext.js.map